// Id that should identify uniquely each row of the table. It is notably the one used when we set the "selection" prop

export const getDefaultRowId = (originalRow: any, index: number): string =>
  String((originalRow as any)?.id || index)
